import lessRequire from '../../../../config/less-require-resolver';
import React from 'react';
import ModalBox from '../../../shared/modal';
import Copy from  '../../../shared/copy-to-clipboard';
import { Field, reduxForm } from 'redux-form';
import classname from 'classname';
import PropTypes from 'prop-types';

import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';

import selectField from '../../../shared/form-elements/select';

lessRequire('modules/streams/components/popups/link-builder.less');

const linkBuilderForm = (props) => {
	const {
		shouldShow,
		links,
		onClose,
		onChangeSids,
		geoOptions,
		sendTestConversion,
		shouldShowTestSuccess,
		shouldDisableCountrySelect,
		intl
	} = props;

	return (
		<ModalBox
			body={modalBody({
				links, onChangeSids, onClose, geoOptions, sendTestConversion,
				shouldShowTestSuccess, intl, shouldDisableCountrySelect
			})}
			isOpen={shouldShow}
			onClose={onClose}
			title={intl('URL потока')}
			className={'modal-overlay__content streams-link-builder-modal'}
			intl={intl}
		/>
	);
};

const modalBody = ({
	links,
	onChangeSids,
	onClose,
	geoOptions,
	sendTestConversion,
	shouldShowTestSuccess,
	intl,
	shouldDisableCountrySelect
}) => {
	const geoOptionsWithFlags = map(geoOptions, o => {
		return { ...o, label: (
			<span className="geo-option">
				<span className={`flag-icon flag-icon-${o.value.toLowerCase()}`}/>
				<span className="name">{o.label}</span>
			</span>
		) };
	});

	return (
		<div className="link-builder">

			{ map(links, (item, i) => {
				const tagsStripped = item && item.link && item.link.replace(/<\/*b>/g, '');
				return item && item.link && (
					<div className="link-builder__link" key={i}>
						<Copy copyText={tagsStripped} intl={intl}>
							<p className="link-builder__link-title" >
								<span className="title">{item.title}</span>
								<span className="link" dangerouslySetInnerHTML={{__html: item.link}} />
							</p>
						</Copy>
					</div>
				);})
			}

			<form className="link-builder__sids"  >
				<Field name="sid1" component={inputField} placeholder="SID1"
					onChange={e=>onChangeSids({sidName:'sid1', value: e.target.value})}
				/>
				<Field name="sid2" component={inputField} placeholder="SID2"
					onChange={e=>onChangeSids({sidName:'sid2', value: e.target.value})}
				/>
				<Field name="sid3" component={inputField} placeholder="SID3"
					onChange={e=>onChangeSids({sidName:'sid3', value: e.target.value})}
				/>
				<Field name="sid4" component={inputField} placeholder="SID4"
					onChange={e=>onChangeSids({sidName:'sid4', value: e.target.value})}
				/>
				<Field name="sid5" component={inputField} placeholder="SID5"
					onChange={e=>onChangeSids({sidName:'sid5', value: e.target.value})}
				/>
			</form>

			<div className="link-builder__bottom">
				<div className="country-select">
					<Field name="country"
						placeholder={intl('Страна')}
						component={selectField}
						searchable={false}
						shouldDisable={shouldDisableCountrySelect}
						options={geoOptionsWithFlags}
					/>
				</div>

				<button className="button test-btn font-proxima-nova-semibold"
					disabled={shouldShowTestSuccess}
					onClick={sendTestConversion}
				>
					{intl(shouldShowTestSuccess ? 'Тестовая конверсия успешно отправлена' : 'Оставить тестовую конверсию')}
				</button>
				<button className="button yellow-btn font-proxima-nova-semibold" onClick={onClose}>{intl('Закрыть')}</button>
			</div>
		</div>
	);
};

const inputField = props => {
	const className = classname({
		'form-element': true,
		'active': isActive(props)
	});

	return (
		<div className={className}>
			<label className="form-element__label">{props.placeholder}</label>
			<input type="text"
				className="form-element__control font-proxima-nova-regular"
				{...props.input}
			/>
		</div>
	);
};

const isActive = props => props.meta.active || !isEmpty(props.input.value);

linkBuilderForm.propTypes = {
	shouldShow: PropTypes.bool,
	shouldShowTestSuccess: PropTypes.bool,
	links: PropTypes.array,
	geoOptions: PropTypes.array,
	onClose: PropTypes.func,
	onChangeSids: PropTypes.func,
	sendTestConversion: PropTypes.func,
	intl: PropTypes.func,
	shouldDisableCountrySelect: PropTypes.bool
};

modalBody.propTypes = {
	shouldShowTestSuccess: PropTypes.bool,
	links: PropTypes.array,
	geoOptions: PropTypes.array,
	onClose: PropTypes.func,
	onChangeSids: PropTypes.func,
	sendTestConversion: PropTypes.func,
	intl: PropTypes.func,
	shouldDisableCountrySelect: PropTypes.bool
};

inputField.propTypes = {
	input: PropTypes.object,
	placeholder: PropTypes.string
};

export default reduxForm({
	form: 'linkBuilderForm'
})(linkBuilderForm);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/streams/components/popups/link-builder.js